export const openTab = (link: string) => window.open(link, '_blank');

export const redirectHome = () => window.location.replace('/');